import request from '../axios'

/**
 * @description 初始化极验插件
 * @param {*} params.clientType h5 wx-h5
 * @returns {} Object
 */
export function gyRegister (params = { clientType: 'h5' }) {
  return request.get(`/project_crm/geeTest/register?t=${new Date() - 0}`, { params: params })
}

/**
 * @description 获取极极验token
 * @param {*} params.geeTestChallenge 流水号，一次完整验证流程的唯一标识
 * @param {*} params.geeTestValidate validate
 * @param {*} params.geeTestSecCode 核心校验数据
 * @param {*} params.phone 流水号，一次完整验证流程的唯一标识
 * @returns {} Object
 */
export function gyValidate (data) {
  return request.post('/project_crm/geeTest/validate', data)
}
